import React, { useEffect, useReducer, useState } from "react";
import * as currency from "@shopify/theme-currency";
import { getUrlWithVariant } from "@shopify/theme-product-form";
import { render } from "react-dom";
import { Product, Options, Variant } from "../types/product";
import { Measure } from "./Measure";
import { SkuObjectGroups, WizardState } from "../types/WigWizard";
import { getOptionsForProduct } from "../utils/product";
import { selectNewColorIfNonExistant } from "./selectNewColorIfNonExistant";
import { addToCart } from "./addToCart";
import { ProductOption } from "./ProductOption";
import { WigSummary } from "./WigSummary";
import { Alert } from "./Popup";
import { WigImages } from "./WigImages";
import { WigWizardReducer } from "../reducers/WigWizardReducer";
import { useUrlSearchParams } from "use-url-search-params";
import { retrieveWizardState, saveWizardState } from "../utils/localStorage";
import { LoginOrContinue } from "./LoginOrContinue";
import { User } from "../types/User";
import { UploadImages } from "./UploadImages";
import { saveUserMeasureMents } from "../utils/metafieldService";
import { SaveWigStyle } from "./SaveWigStyle";
import ReCAPTCHA from "react-google-recaptcha";
import { CameraIntro } from "./CameraIntro";
import skinToneMapUtil from "../utils/skinToneMap";
import checkIfLoggedIn from "../utils/checkIfLoggedIn";
import { shippingEstimate } from "../utils/shippingEstimate";
import { getSkuObject } from "../utils/getSkuObject";
import move from "../utils/reorderArray";
import partIconMap from "../utils/partIconMap";

(function init() {
  const selectors = {
    root: "[data-wig-wizard]",
  };

  const rootElement = document.querySelector(selectors.root);

  if (!rootElement) return;

  render(<WigWizard />, rootElement);
})();

function WigWizard() {
  const selectors = {
    product: "[data-product]",
    allProducts: "[data-all-products]",
    allOptions: "[data-all-options]",
    userData: "[data-customer-data]",
    addToCartButton: "[data-add-to-cart-button]",
    measureButton: "[data-start-measuring]",
    gorgiasChatContainer: "#gorgias-chat-container",
    cameraVideoId: "h5b8n01ejwdl2",
  };

  const product: Product = JSON.parse(
    document.querySelector(selectors.product).innerHTML
  );
  let products: Product[] = JSON.parse(
    document.querySelector(selectors.allProducts).innerHTML
  );

  products= products.filter((val)=>val.handle==="kinky-curly"||val.handle==="kinky-straight"||val.handle==="very-straight"||val.handle==="very-straight-blonde"||
  val.handle==="very-wavy"||val.handle==="wavy") 


  const allOptions = JSON.parse(
    document.querySelector(selectors.allOptions).innerHTML
  );

  const user: User = JSON.parse(
    document.querySelector(selectors.userData).innerHTML
  );

  const urlSearchParams = new URLSearchParams(window.location.search);
  const variantQuerystring = parseInt(urlSearchParams.get("variant"));
  const variant = product.variants.find(
    (variant) => variant.id === variantQuerystring
  );

  const storedState = retrieveWizardState();

  const initialState: WizardState = {
    steps: [{}, {}, {}, {}],
    active: 0,
    capSize: user.cap_size,
    laceTint: user.lace_tint,
    laceTintDescription: user.lace_tint_description,
    s3BucketFolder: user.s3_bucket_folder,
    skuImage: true,
    ...storedState,
    SkinTone:
      urlSearchParams.get("shade") || storedState?.SkinTone || "black-cherry",
    Cut: urlSearchParams.get("cut") || storedState?.Cut || "uncut",
    Part_Style:
      urlSearchParams.get("part_style") || storedState?.Part_Style || "middle",
    Prep: urlSearchParams.get("prep") || storedState?.Prep || "low bun",
    Bang: urlSearchParams.get("bang") || storedState?.Bang || "no",
    Hair_Styling:
    urlSearchParams.get("hair_styling") || storedState?.Hair_Styling|| "natural (un-styled)",
    Adhesive:
      urlSearchParams.get("adhesive") || storedState?.Adhesive || "Adhesive",
    Product: product.handle,
    Color:
      variant?.option1 || storedState?.Color || product.variants[0].option1,
    Length:
      variant?.option2 || storedState?.Length || product.variants[0].option2,
    Type: variant?.option3 || storedState?.Type || product.variants[0].option3,
    captchaCompleted: true,
  };

  async function cartAdd() {
    try {
      await addToCart(selectedVariant, state);
      location.pathname = "/cart";
    } catch (e) {
      console.log("error: ", e);
      dispatch({
        type: "Error",
        value:
          "There was an error adding to cart. Please try again or contact support",
      });
    }
  }

  const [state, dispatch] = useReducer(WigWizardReducer, initialState);
  const [cameraVisible, setCameraVisible] = useState(false);
  const [selectedVariant, setSelectedVariant] = useState<Variant>();
  const [skuObject, setSkuObject] = useState<SkuObjectGroups>();
  const [selectedProduct, setSelectedProduct] = useState<Product>();
  const [options, setOptions] = useState<Options[]>();
  const [showSummary, setShowSummary] = useState(false);
  const [searchParams, setSearchParams] = useUrlSearchParams(
    {
      prep: state.Prep,
      adhesive: state.Adhesive,
      part_style: state.Part_Style,
      cut: state.Cut,
      shade: state.SkinTone,
    },
    null,
    true
  );
  const [showLastStep, setShowLastStep] = useState(false);
  const [showIntro, setShowIntro] = useState(false);
  // const [shipping, setShipping] = useState("5-7");
  const [shipping, setShipping] = useState("12-14");

  const skinToneMap = skinToneMapUtil();

  useEffect(() => {
    const value ="ginger"
    state.clicked = "Prep";
    dispatch({ type: "SkinTone", value });

  }, []);



  useEffect(()=>{
    const lengthDiv= document.getElementById('Length')
    if(lengthDiv && urlSearchParams.get("browse") ==='true'){
      lengthDiv.scrollIntoView({behavior: "smooth",block: "end", inline: "nearest"});
    }
    
  },[])

  useEffect(() => {
    if (state.uploadedWithEmail) saveUserMeasureMents(state, user);
  }, [state.uploadedWithEmail]);

  useEffect(() => {
    setSearchParams({
      prep: state.Prep,
      adhesive: state.Adhesive,
      part_style: state.Part_Style,
      cut: state.Cut,
      shade: state.SkinTone,
    });
  }, [state.Prep, state.Cut, state.Part_Style, state.SkinTone, state.Adhesive]);

  useEffect(() => {
    saveWizardState(state);
  }, [state]);

  useEffect(() => {
    async function uploadAndSkip() {
      setShowLastStep(true);
      await UploadImages({
        state,
        dispatch,
        redirectAfterLogin: !user.email ? location.href : "",
        email: user.email,
      });
      dispatch({ type: "SkippedToLastStep" });
    }
    if (state.skipToLastStep) uploadAndSkip();
  }, [state.skipToLastStep]);

  useEffect(() => {
    if (selectedVariant) setSkuObject(getSkuObject(selectedVariant));
  }, [selectedVariant]);

  useEffect(() => {
    setSelectedProduct(
      products.find((product) => product.handle === state.Product)
    );
  }, [state]);

  useEffect(() => {
    selectNewColorIfNonExistant(options, state, dispatch);
  }, [state.Product, options]);

  useEffect(() => {
    const match = selectedProduct?.variants.find(
      ({ option1, option2, option3 }) =>
        option1 === state.Color &&
        option2 === state.Length &&
        option3 === state.Type
    );
    const variant = match || selectedProduct?.variants[0];
    if (variant) setSelectedVariant(match || selectedProduct?.variants[0]);
  }, [selectedProduct]);

  useEffect(() => {
    const url = getUrlWithVariant(window.location.href, selectedVariant?.id);
    const newUrl = url.replace(
      /(\/products\/)([^\?\/\#]+)(.+)?/gm,
      `$1${state.Product}$3`
    );
    window.history.replaceState({ path: newUrl }, "", newUrl);
  }, [selectedVariant]);

  useEffect(() => {
    setOptions(getOptionsForProduct(selectedProduct));
  }, [selectedProduct]);

  useEffect(() => {
    // if 'blunt' is selected and any other length than 14" is clicked: change cut
    if (
      state.clicked === "Length" &&
      state.Length !== '14"' &&
      state.Cut === "blunt"
    ) {
      dispatch({ type: "Cut", value: "uncut" });
    } else if (
      state.clicked === "Length" &&
      state.Length !== '10"' &&
      state.Cut === "bob"
    ) {
      dispatch({ type: "Cut", value: "uncut" });
    } else if (
      state.clicked === "Product" &&
      state.Product === "kinky-curly" &&
      state.Length === '10"'
    ) {
      dispatch({ type: "Length", value: '14"' });
    } else if (state.Length === '10"') {
      state.Cut='bob'
    } else if (state.clicked === "Cut" && state.Bang === "yes") {
      state.Type = "Closure";
    }
    
  }, [state.clicked]);

  useEffect(() => {
    if (selectedVariant) setShipping(shippingEstimate(selectedVariant));
  }, [selectedVariant]);

  function close() {
    setShowLastStep(false);
    document
      .querySelector(selectors.measureButton)
      .scrollIntoView({ behavior: "smooth" });
  }

  function login() {
    saveWizardState(state, location.href);
    location.href = "/account/login";
  }

  function bangSetup() {
    if (document.getElementById("bangCheckBox").checked) {
      const value = "yes";
      dispatch({ type: "Bang", value });
      state.clicked = "Bang";
    } else {
      state.Bang = "no";
      const value = state.Bang;
      dispatch({ type: "Bang", value });
      state.clicked = "Bang";
    }
  }

  useEffect(() => {
    if (cameraVisible) {
      document
        .querySelector(selectors.gorgiasChatContainer)
        ?.classList.add("hidden", "lg:block");
    } else {
      document
        .querySelector(selectors.gorgiasChatContainer)
        ?.classList.remove("hidden", "lg:block");
    }
  }, [cameraVisible]);

  function showPopup() {
    dispatch({
      type: "Error",
      value: "Are you sure you want to exit tailoring your new wig?",
    });
    dispatch({ type: "ErrorContext", value: "" });
  }

  

  return (
    <>
      <div className="lg:pb-20">
        <div
          className="sticky top-0 bg-white text-center flex flex-col lg:pt-5 lg:float-right lg:top-[104px] lg:w-[calc(45%-60px)] z-10 shadow-lg lg:shadow-none"
          data-product-main
        >
          <SaveWigStyle
            className="absolute left-4 top-8 lg:top-14 cursor-pointer z-10 transition-all duration-500"
            user={user}
            searchParams={searchParams}
            setSearchParams={setSearchParams}
            selectedVariant={selectedVariant}
            dispatch={dispatch}
          />

          <button
            onClick={showPopup}
            className="lg:hidden absolute right-4 top-8 z-20 cursor-pointer"
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0.509484 16.2458C0.314222 16.4411 0.314222 16.7577 0.509484 16.953C0.704746 17.1482 1.02133 17.1482 1.21659 16.953L8.99993 9.16961L16.7833 16.953C16.9785 17.1482 17.2951 17.1482 17.4904 16.953C17.6856 16.7577 17.6856 16.4411 17.4904 16.2458L9.70704 8.4625L16.7833 1.38627C16.9785 1.19101 16.9785 0.874424 16.7833 0.679162C16.588 0.4839 16.2714 0.4839 16.0762 0.679162L8.99993 7.7554L1.9237 0.679163C1.72844 0.483901 1.41185 0.483901 1.21659 0.679163C1.02133 0.874425 1.02133 1.19101 1.21659 1.38627L8.29283 8.4625L0.509484 16.2458Z"
                fill="black"
              />
            </svg>
          </button>

          <p className="text-xs leading-none mb-1 hidden lg:block">
            Some customization options might not appear in the preview image
            below
          </p>

          <WigImages
            selectedVariant={selectedVariant}
            state={state}
            skuObject={skuObject}
            dispatch={dispatch}
          />

          <div className="hidden lg:block pb-11">
            <button
              className="text-btn-m lg:text-btn-d cursor-pointer font-semibold uppercase bg-black text-white block text-center p-4 mt-6 w-full mb-2 disabled:opacity-10 disabled:cursor-auto max-w-[400px] mx-auto relative"
              onClick={() => cartAdd()}
              data-add-to-cart-button
            >
              Add to cart •{" "}
              {currency.formatMoney(
                selectedVariant?.price,
                "${{amount_no_decimals}}"
              )}
            </button>

            <p className="text-base leading-none text-center mt-3">
              Estimated USA delivery {shipping} business days | Free shipping
            </p>

            {!checkIfLoggedIn() && (
              <div className="mt-10">
                <a
                  className="font-semibold text-base underline cursor-pointer"
                  onClick={() => login()}
                >
                  Sign in to add style to profile
                </a>
              </div>
            )}
          </div>

          <div
            className="flex flex-row justify-between text-3xl mt-4 px-9 items-center cursor-pointer lg:hidden"
            onClick={() => setShowSummary(!showSummary)}
          >
            <div className="flex items-baseline">
              <h4>Your tailored Wig:</h4>
              <p className="text-base font-semibold uppercase ml-1">
                {currency.formatMoney(
                  selectedVariant?.price,
                  "${{amount_no_decimals}}"
                )}
              </p>
            </div>
            <div
              className={`w-2 h-2 border-black border-r border-b transition-transform origin-center ${
                showSummary ? "rotate-[225deg]" : "rotate-45"
              }`}
            ></div>
          </div>

          <p className="text-xs leading-none tracking-tighter text-left pb-4 px-9 lg:hidden max-w-[340px]">
            Some customization options might not appear{" "}
            {showSummary ? "in the preview image above." : ""}
          </p>

          {showSummary && <WigSummary state={state} />}
        </div>

        <div
          className="px-4 lg:px-0 lg:w-[calc(55%-60px)]"
          data-product-content
        >
          <div className="hidden lg:block">
            <h2>Tailor your wig</h2>
            <p className="mt-6">
              Create the look that makes you feel the best. Choose every detail
              from hair texture to part style
            </p>
          </div>

          {/* <div className="bg-white rounded-md lg:border lg:border-gray-300 pt-6 px-5 pb-8 mt-4 lg:mt-16">
            <h3>Shop With Confidence</h3>
            <p className="text-product-m lg:text-product-d pt-2">
              Select the model whose skin tone is close to yours & feel
              confident in the look you create. Don’t worry, our AI will match
              you with the perfect lace tint when it’s time to buy your wig.
            </p>
            <div className="text-pill grid grid-cols-3 mt-8 gap-y-4 gap-x-5 lg:gap-x-4">
              {skinToneMap.map(({ value, label, icon }) => {
                return (
                  <label className="text-center cursor-pointer">
                    <input
                      type="radio"
                      name="SkinTone"
                      className="hidden peer"
                      checked={value === state.SkinTone}
                      onChange={() => {
                        dispatch({ type: "SkinTone", value });
                        dispatch({ type: "Animated" });
                      }}
                    />
                    <img
                      data-src={icon}
                      className="lazyload ring-offset-2 ring-black rounded-full peer-checked:ring-1 peer-disabled:opacity-20 m-auto"
                    />
                    <p className="text-center capitalize mt-4">{label}</p>
                  </label>
                );
              })}
            </div>
          </div> */}

          <div className="bg-white rounded-md lg:border lg:border-gray-300 pt-6 px-5 pb-8 mt-4">
            <h3>Texture</h3>
            <p className="text-product-m lg:text-product-d pt-2">
              Hair textures range from straight to kinky, so that you can
              personalize your look! You might want to go for a look that mimics
              your natural pattern.
            </p>
            <div className="text-pill flex flex-row justify-start grow flex-wrap mt-8 gap-y-4 gap-x-4">
              {move(
                3,
                4,
                move(0, 1, move(3, 5, move(0, 2, move(0, 3, products))))
              ).map((product, index) => {
                return product.title === "Kinky Curly" ? (
                  <span
                    className={
                      index === 3
                        ? "min-w-[calc(50%-10px)] sm:min-w-[calc(25%-15px)] sm:grow-0 text-center relative inline-block"
                        : "min-w-[calc(50%-10px)] sm:min-w-[calc(25%-15px)] sm:grow last:grow-0 text-center relative inline-block"
                    }
                  >
                    <label>
                      <input
                        type="radio"
                        name="product"
                        className="hidden peer"
                        value={product.id}
                        onChange={() => {
                          dispatch({ type: "Product", value: product.handle });
                          dispatch({ type: "Static" });
                        }}
                        checked={state.Product === product.handle}
                      />

                      <div className="border border-black rounded-full px-2 py-2.5 peer-checked:bg-black peer-checked:text-white peer-disabled:opacity-20 capitalize">
                        {product.title}
                      </div>
                    </label>
                    <span className="absolute top-0 right-1 inline-flex items-center justify-center px-2 py-1 leading-nonetransform translate-x-1/2 -translate-y-1/2">
                      <img
                        className="h-10 w-26"
                        src="https://cdn.shopify.com/s/files/1/0562/6442/5517/files/new.png?v=1654621376"
                      ></img>
                    </span>
                  </span>
                ) : (
                  <label
                    className={
                      index === 3
                        ? "min-w-[calc(50%-10px)] sm:min-w-[calc(25%-15px)] sm:grow-0 text-center"
                        : "min-w-[calc(50%-10px)] sm:min-w-[calc(25%-15px)] sm:grow last:grow-0 text-center"
                    }
                  >
                    <input
                      type="radio"
                      name="product"
                      className="hidden peer"
                      value={product.id}
                      onChange={() => {
                        dispatch({ type: "Product", value: product.handle });
                        dispatch({ type: "Static" });
                      }}
                      checked={state.Product === product.handle}
                    />
                    <div className="border border-black rounded-full px-2 py-2.5 peer-checked:bg-black peer-checked:text-white peer-disabled:opacity-20 capitalize">
                      {product.title}
                    </div>
                  </label>
                );
              })}
            </div>
          </div>

          {options?.map((option, index) => {
            return (
              <>
                <ProductOption
                  option={option}
                  allOptions={allOptions}
                  index={index}
                  dispatch={dispatch}
                  state={state}
                />
                {index === 1 && (
                  <>
                    <div className="bg-white rounded-md lg:border lg:border-gray-300 pt-6 px-5 pb-8 mt-4">
                      <h3>Hair cut</h3>
                      <p className="text-product-m lg:text-product-d pt-2">
                        A good cut can go a long way. Our stylist will cut your
                        hair in the style of your choice, unless you opt to
                        leave it in the natural state.
                      </p>
                      <div className="text-pill grid grid-cols-2 sm:grid-cols-4 mt-8 gap-y-4 gap-x-5 lg:gap-x-4">
                        {[
                          '10"' === state.Length ? null : "uncut",
                          '10"' === state.Length ? null : "layers",
                          '14"' === state.Length ? "blunt" : null,
                          '10"' === state.Length ? "bob" : null,
                        ]
                          .filter((o) => o)
                          .map((value) => {
                            return value === "bob" ? (
                              <span
                                className={"text-center relative inline-block"}
                              >
                                <label>
                                  <input
                                    type="radio"
                                    name="Cut"
                                    className="hidden peer"
                                    checked={value === state.Cut}
                                    onChange={() => {
                                      dispatch({ type: "Cut", value });
                                      dispatch({ type: "Static" });
                                    }}
                                  />
                                  <div className="border border-black rounded-full px-2 py-2.5 peer-checked:bg-black peer-checked:text-white peer-disabled:opacity-20 capitalize">
                                    {value}
                                  </div>
                                </label>
                                <span className="absolute top-0 right-2 inline-flex items-center justify-center px-2 py-1 leading-nonetransform translate-x-1/2 -translate-y-1/2">
                                  <img
                                    className="h-10 w-26"
                                    src="https://cdn.shopify.com/s/files/1/0562/6442/5517/files/new.png?v=1654621376"
                                  ></img>
                                </span>
                              </span>
                            ) : (
                              <label className="text-center">
                                <input
                                  type="radio"
                                  name="Cut"
                                  className="hidden peer"
                                  checked={value === state.Cut}
                                  onChange={() => {
                                    dispatch({ type: "Cut", value });
                                    dispatch({ type: "Static" });
                                  }}
                                />
                                <div className="border border-black rounded-full px-2 py-2.5 peer-checked:bg-black peer-checked:text-white peer-disabled:opacity-20 capitalize">
                                  {value}
                                </div>
                              </label>
                            );
                          })}
                      </div>
                      {state.Product != "kinky-curly" && (
                        <div className="mt-10 flex">
                          <input
                            className="w-4 h-4  bg-white border-green-600 text-green-600 focus:ring-green-600"
                            type="checkbox"
                            id="bangCheckBox"
                            onClick={() => {
                              bangSetup();
                            }}
                            checked={state.Bang === "yes"}
                          />
                          <label className="text-product-m lg:text-product-d  pl-2  inline-block ">
                            Check this box if you would like us to cut Bangs
                            into your wig.
                          </label>
                        </div>
                      )}
                    </div>

                    {/*add hair styling section  */}
                    <div className="bg-white rounded-md lg:border lg:border-gray-300 pt-6 px-5 pb-8 mt-4">
                      <h3>Hair Styling</h3>
                      <p className="text-product-m lg:text-product-d pt-2">
                      We offer 3 hair styling options on all of our wigs.
                      </p>
                      <div className="text-pill grid grid-cols-2 sm:grid-cols-3 mt-8 gap-y-4 gap-x-5 lg:gap-x-4">

                        {["natural (un-styled)", 
                        'very-straight-blonde' === state.Product ? "straightened" : null,
                        'very-straight' === state.Product ? "straightened" : null,
                        'kinky-straight' === state.Product ? "straightened" : null,
                        'very-wavy' === state.Product ? "straightened" : null,
                        'wavy' === state.Product ? "straightened" : null,
                        'very-straight-blonde' === state.Product ? "curled" : null,
                        'very-straight' === state.Product ? "curled" : null,
                        'kinky-straight' === state.Product ? "curled" : null,
                        'wavy' === state.Product ? "curled" : null,
                   
                        
                        ]
                        .filter((o) => o)
                        .map((value) => {
                          return (
                            <label
                              className="text-center"
                              style={{ border: "lid red" }}
                            >
                              <input
                                type="radio"
                                name="Hair_Styling"
                                className="hidden peer"
                                checked={value === state.Hair_Styling}
                                onChange={() =>
                                  dispatch({ type: "Hair_Styling", value })
                                }
                              />
                              <div className="border border-black rounded-full px-2 py-2.5 peer-checked:bg-black peer-checked:text-white peer-disabled:opacity-20 capitalize">
                                {value}
                              </div>
                            </label>
                          );
                        })}
                      </div>
                    </div>

                    {/* Part Style */}
                    <div className="bg-white rounded-md lg:border lg:border-gray-300 pt-6 px-5 pb-8 mt-4">
                      <h3>Part Style</h3>
                      <p className="text-product-m lg:text-product-d pt-2">
                        We offer 3 signature parting options on all of our wigs.
                        Whether you choose a closure or frontal, you will have
                        ample space to switch up your parts as you choose.
                      </p>
                      <div className="text-pill grid grid-cols-3 mt-8 gap-y-4  gap-x-5 lg:gap-x-4">
                        {["left", "middle", "right"].map((value) => {
                          return (
                            <label className="text-center cursor-pointer">
                              <input
                                type="radio"
                                name="Part_Style"
                                className="hidden peer"
                                checked={value === state.Part_Style}
                                onChange={() => {
                                  dispatch({ type: "Part_Style", value });
                                  dispatch({ type: "Static" });
                                }}
                              />
                              <img
                                data-src={
                                  value === state.Part_Style
                                    ? partIconMap.selected[value]
                                    : partIconMap[value]
                                }
                                key={
                                  value === state.Part_Style
                                    ? partIconMap.selected[value]
                                    : partIconMap[value]
                                }
                                className="lazyload ring-offset-2 ring-black rounded-full peer-checked:ring-1 peer-disabled:opacity-20 capitalize m-auto"
                              />
                              <p className="text-center capitalize mt-2">
                                {value}
                              </p>
                            </label>
                          );
                        })}
                      </div>
                    </div>
                  </>
                )}
              </>
            );
          })}

          <div className="bg-white rounded-md lg:border lg:border-gray-300 pt-6 px-5 pb-8 mt-4">
            <h3>Adhesive or Glueless?</h3>
            <p className="text-product-m lg:text-product-d pt-2">
              Planning to install your wig with adhesive? We’ll leave a bit of
              extra lace for you to work with. If you want to wear it without
              adhesive, we’ll cut the extra lace off. <br /> <br />
              Note: Each wig comes pre-cut and pre-plucked at the hairline with
              pre-tinted lace for the most natural look
            </p>
            <div className="text-pill grid grid-cols-2 sm:grid-cols-4 mt-8 gap-y-4 gap-x-5 lg:gap-x-4">
              {["Adhesive", "Glueless"].map((value) => {
                return (
                  <label className="text-center" style={{ border: "lid red" }}>
                    <input
                      type="radio"
                      name="Adhesive"
                      className="hidden peer"
                      checked={value === state.Adhesive}
                      onChange={() => dispatch({ type: "Adhesive", value })}
                    />
                    <div className="border border-black rounded-full px-2 py-2.5 peer-checked:bg-black peer-checked:text-white peer-disabled:opacity-20 capitalize">
                      {value}
                    </div>
                  </label>
                );
              })}
            </div>
          </div>

          <div className="bg-white rounded-md lg:border lg:border-gray-300 pt-6 px-5 pb-8 mt-4">
            <h3>Hair Prep</h3>
            <p className="text-product-m lg:text-product-d pt-2">
              How will you prep your natural hair before applying your wig?
            </p>
            <div className="text-pill grid grid-cols-2 sm:grid-cols-4 mt-8 gap-y-4 gap-x-5 lg:gap-x-4">
              {["low bun", "flat braids", "no prep"].map((value) => {
                return (
                  <label
                    className={
                      value === "no prep"
                        ? "col-span-2 text-center"
                        : "text-center"
                    }
                  >
                    <input
                      type="radio"
                      name="Prep"
                      className="hidden peer"
                      checked={value === state.Prep}
                      onChange={() => dispatch({ type: "Prep", value })}
                    />
                    <div className="border border-black rounded-full px-2 py-2.5 peer-checked:bg-black peer-checked:text-white peer-disabled:opacity-20 capitalize">
                      {value === "no prep"
                        ? "I have little to no hair to prep"
                        : value}
                    </div>
                  </label>
                );
              })}
            </div>
          </div>

          {showIntro && state.captchaCompleted && (
            <div className="fixed top-0 left-0 z-30 lg:top-1/2 lg:left-1/2 lg:-translate-x-2/4 lg:-translate-y-2/4 lg:px-4 lg:w-full pointer-events-none">
              <div className="bg-white lg:max-w-[1232px] lg:mx-auto w-screen lg:w-full h-screen lg:h-auto pointer-events-auto">
                <CameraIntro
                  close={() => setShowIntro(false)}
                  next={() => {
                    setShowIntro(false);
                    dispatch({ type: "StartCamera" });
                    setTimeout(() => {
                      setCameraVisible(true);
                    }, 1000);
                  }}
                />
              </div>
            </div>
          )}

          {cameraVisible && state.captchaCompleted && (
            <div className="fixed top-0 left-0 bg-white w-screen h-screen z-20">
              <Measure
                setCameraVisible={setCameraVisible}
                state={state}
                dispatch={dispatch}
                user={user}
              />
            </div>
          )}

          {showIntro && !state.captchaCompleted && (
            <div className="fixed top-0 left-0 w-full h-full bg-black/20 flex justify-center items-center z-40">
              <ReCAPTCHA
                onChange={() => dispatch({ type: "CaptchaCompleted" })}
                sitekey="6LcVjZ8eAAAAACRYMvBrqxC-5O33MAgW7dUHJAGG"
              />
            </div>
          )}

          {showLastStep && (
            <div className="fixed top-0 left-0 bg-white w-screen h-screen z-20 p-4 flex flex-col h-full">
              <div className="flex justify-between items-center flex-col">
                <svg
                  onClick={() => close()}
                  className="cursor-pointer self-end"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M0.509484 16.2458C0.314222 16.4411 0.314222 16.7577 0.509484 16.953C0.704746 17.1482 1.02133 17.1482 1.21659 16.953L8.99993 9.16961L16.7833 16.953C16.9785 17.1482 17.2951 17.1482 17.4904 16.953C17.6856 16.7577 17.6856 16.4411 17.4904 16.2458L9.70704 8.4625L16.7833 1.38627C16.9785 1.19101 16.9785 0.874424 16.7833 0.679162C16.588 0.4839 16.2714 0.4839 16.0762 0.679162L8.99993 7.7554L1.9237 0.679163C1.72844 0.483901 1.41185 0.483901 1.21659 0.679163C1.02133 0.874425 1.02133 1.19101 1.21659 1.38627L8.29283 8.4625L0.509484 16.2458Z"
                    fill="black"
                  />
                </svg>
              </div>
              <LoginOrContinue
                user={user}
                continueFn={() => {
                  setShowLastStep(false);
                  document
                    .querySelector(selectors.measureButton)
                    .scrollIntoView({ behavior: "smooth" });
                }}
                state={state}
              />
            </div>
          )}

          {state.error && (
            <Alert
              user={user}
              selectedVariant={selectedVariant}
              searchParams={searchParams}
              setSearchParams={setSearchParams}
              message={state.error}
              messageContext={state.errorContext}
              buttonAction={() => {
                dispatch({ type: "ResolveError" });
                setCameraVisible(false);
              }}
            />
          )}
        </div>
      </div>

      <div
        className={`pt-6 text-center sticky lg:hidden bg-gray-100 top-[0] px-4 ${
          checkIfLoggedIn() ? "pb-6" : ""
        }`}
        data-add-to-cart-container
      >
        <button
          className="text-btn-m cursor-pointer font-medium uppercase bg-black text-white block text-center p-4 w-full mb-2 disabled:opacity-10 disabled:cursor-auto relative"
          onClick={() => cartAdd()}
          data-add-to-cart-button
        >
          Add to cart
        </button>
        <p className="text-xs leading-none text-center mt-3">
          Estimated USA delivery {shipping} business days | Free shipping
        </p>

        {!checkIfLoggedIn() && (
          <div className="mt-10 pb-6">
            <a
              className="font-semibold text-base underline"
              href="/account/login"
            >
              Sign in to add style to profile
            </a>
          </div>
        )}
      </div>
    </>
  );
}
